import permissions from "app/permissions";
import React, { useCallback, useEffect, useState } from "react";
import { Datagrid, DateField, FunctionField, ListContextProvider, Title, TopToolbar, useList } from "react-admin";
import SecuredComponent from "server/security/SecuredComponent";
import dataProvider from "server/dataProvider";
import { specialistRequests } from "api/specialistApi";
import HistoryDialog from "./HistoryDialog";
import NewVersionDialog from "./NewVersionDialog";
import { useNotifyError } from "utils/useNotifyError";

const ListHealthcareCourseFeeDistributions = () => {
  const notifyError = useNotifyError();
  const [data, setData] = useState([]);

  const fetchCurrent = useCallback(async () => {
    try {
      const response = await dataProvider.customRequest(specialistRequests.getHealthcareCoursesFeeDistributions());
      const record = response.data;
      setData(record ? [{ id: 1, ...record }] : []);
    } catch (err) {
      if (err?.status !== 404) {
        notifyError(err);
      }
    }
  }, [notifyError]);

  useEffect(() => {
    fetchCurrent();
  }, [fetchCurrent]);

  const listContext = useList({ data });

  return (
    <>
      <Title title="Разпределение на такси курсове за здравни грижи" />
      <TopToolbar>
        <SecuredComponent permission={permissions.canManageHealthcareCourseFeeDistributions}>
          <NewVersionDialog onSuccess={fetchCurrent} />
        </SecuredComponent>
        <SecuredComponent permission={permissions.canPreviewHealthcareCourseFeeDistributions}>
          <HistoryDialog />
        </SecuredComponent>
      </TopToolbar>
      <ListContextProvider value={listContext}>
        <Datagrid
          bulkActionButtons={false}
          rowClick={false}
          sx={{
            "& .RaDatagrid-headerCell": {
              textAlign: "left",
            },
          }}
        >
          <FunctionField
            label="Процент за обучаващ"
            render={rec => `${rec.trainerPercentage}%`}
          />
          <FunctionField
            label="Процент за БАПЗГ"
            render={rec => `${rec.bapzgPercentage}%`}
          />
          <FunctionField
            label="Процент за Университет"
            render={rec => `${rec.universityPercentage}%`}
          />
          <DateField
            source="effectiveFrom"
            label="В сила от"
            locales="bg-BG"
          />
          <DateField
            source="createdOn"
            label="Създадено на"
            locales="bg-BG"
            showTime
          />
        </Datagrid>
      </ListContextProvider>
    </>
  );
};

export default ListHealthcareCourseFeeDistributions;
